import * as Sentry from "@sentry/react";

Sentry.init({
  // Your GlitchTip project DSN
  dsn: "https://0dfe9e354ecd4e13a960ef607156850b@glitchtip-web-production-2c82.up.railway.app/4",
  // BrowserSession integration while keeping the rest (including tracing).
  integrations: (defaultIntegrations) =>
    defaultIntegrations.filter(
      (integration) => integration.name !== "BrowserSession",
    ),

  tracesSampleRate: 0.05, // Optional: adjust performance tracking,
  enableLogs: true,
});
